import * as RadixSelect from '@radix-ui/react-select'
import { styled } from '../../../config'

export const SelectItemPrimitive = styled(RadixSelect.SelectItem, {
  fontSize: '14px',
  linHeight: 1,
  borderRadius: '$4',
  display: 'flex',
  alignItems: 'center',
  height: '25px',
  position: 'relative',
  userSelect: 'none',
  padding: '10px 12px',
  cursor: 'pointer',
  variants: {
    variant: {
      dark: {
        '&[data-highlighted]': {
          backgroundColor: '$gray0700',
          outline: 'none'
        }
      }
    }
  }
})
